module.exports = __webpack_public_path__ + "static/media/pen.88777892.svg";